export function getCurrentDate(){
    return new Date().getDate()
}